import { DismissalSuccessResultCreator, UndoDismissalSuccessResultCreator } from '../index';
export class DismissRecommendationRequestBroker {
  extract(response) {
    return this.isDismissRecommendationResponse(response) ? response.dismissRecommendation : null;
  }
  getSuccessResultCreator(response, mutationResponse) {
    return new DismissalSuccessResultCreator(response, this.getDismissalData(mutationResponse));
  }
  getDismissalData({
    dismissal
  }) {
    if (!dismissal) {
      throw new Error('Dismissal data is missing');
    }
    return dismissal;
  }
  isDismissRecommendationResponse(response) {
    var _response$hasOwnPrope;
    return (_response$hasOwnPrope = response === null || response === void 0 ? void 0 : response.hasOwnProperty('dismissRecommendation')) !== null && _response$hasOwnPrope !== void 0 ? _response$hasOwnPrope : false;
  }
}
export class UndoDismissalRequestBroker {
  extract(response) {
    return this.isUndoDismissalResponse(response) ? response.undoDismissal : null;
  }
  getSuccessResultCreator(response, undoDismissalResponse) {
    return new UndoDismissalSuccessResultCreator(response, this.getUndoDismissalResult(undoDismissalResponse));
  }
  getUndoDismissalResult(undoDismissalResponse) {
    if (!undoDismissalResponse.result) {
      throw new Error('Undo dismissal result is missing');
    }
    return undoDismissalResponse.result;
  }
  isUndoDismissalResponse(response) {
    var _response$hasOwnPrope2;
    return (_response$hasOwnPrope2 = response === null || response === void 0 ? void 0 : response.hasOwnProperty('undoDismissal')) !== null && _response$hasOwnPrope2 !== void 0 ? _response$hasOwnPrope2 : false;
  }
}